import { useLocalization } from "@i18n";
import { LoadingBlurDiv } from "@shared/components";

import { useAdminComplexesUrlQuery } from "../api/complexes";
import { AdminComplexesTab } from "../components/organisms";

const AdminComplexesPage = () => {
  const { translate } = useLocalization();
  const { query, setFilters, resetFilters, currentFilters } =
    useAdminComplexesUrlQuery();

  return (
    <div className="flex flex-col gap-4">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold">
          {translate("admin.complexes.page.title")}
        </h1>
        <p className="text-sm text-muted-foreground">
          {translate("admin.complexes.page.subtitle")}
        </p>
      </header>

      <LoadingBlurDiv isLoading={query.isFetching}>
        <AdminComplexesTab
          complexes={query.data?.data || []}
          paginatedMeta={query.data?.meta}
          isLoading={query.isFetching}
          onFilter={setFilters}
          onClearFilter={resetFilters}
          initialFilters={currentFilters}
        />
      </LoadingBlurDiv>
    </div>
  );
};

export default AdminComplexesPage;
